import React from 'react';
import { Box, Grid } from '@mui/material';
import Dinero from 'views/rebranded-module/common/utils/Dinero';
import moneyFormat from 'views/rebranded-module/common/utils/moneyFormat';
import { DEAL_TYPES } from 'views/common/utils/constants';
import useCalculateDealValue from 'views/rebranded-module/common/hooks/useCalculateDealValue';
import { StyledBox } from 'views/rebranded-module/deals-module/DealDetailsViewV2/components/DiscountSection/DiscountSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import { Typography700 } from 'views/rebranded-module/common/components';
import Typography500 from 'views/common/components/UI/Typography500';
import { RiFireLine } from 'react-icons/ri';
const DiscountSection = (props:any) => {
  const { deal , disabled } = props;
  const content = useContent('DealDetailsPage');
  const dealValue = useCalculateDealValue();
  const dealValueData = dealValue(
    deal.value_wc,
    deal.discounted_price,
    deal.deal_type.sym_id,
    { paid_days: deal.paid_days, free_days: deal.free_days },
  );
  const formatMoneyValue = (moneyObj) => {
    if (!moneyObj) return '';
    const { amount, currency_code, precision } = moneyObj;
    return moneyFormat(
      Dinero({
        amount,
        currency: currency_code,
        precision,
      }),
    );
  };
  const isZeroPercentDeal = deal.deal_type.sym_id === DEAL_TYPES.DISCOUNT_PERCENT && +deal.discounted_price === 0;

  return (
    <StyledBox py={3} className={disabled && 'DSSDisabled'}>
      <Box textAlign="center">
        {isZeroPercentDeal ? (
          <Typography700
            variant="h5"
            component="span"
            color="primary"
            mb={1}
          >
            {deal.tagline}
          </Typography700>
        ) : (
          <Typography700
            variant="h5"
            component="span"
            color="primary"
            mb={1}
            dangerouslySetInnerHTML={{ __html: dealValueData.dealValue }}
          />
        )}
        {dealValueData.oldValue && (
          <Typography500
            variant="body1"
            component="p"
            className="DSSoldPrice"
            dangerouslySetInnerHTML={{
              __html: dealValueData.oldValue,
            }}
          />
        )}
      </Box>

      {[
        DEAL_TYPES.TOUR,
        DEAL_TYPES.PACKAGE_PRICE,
        DEAL_TYPES.DISCOUNT_PERCENT,
        DEAL_TYPES.DISCOUNT_AMOUNT,
        DEAL_TYPES.BUY_ONE_DAY_GET_ONE,
        DEAL_TYPES.BUY_X_DAYS_GET_Y_DAYS,
        DEAL_TYPES.TOUR_WITH_OPERATIONAL_DAYS,
      ].indexOf(deal.deal_type.sym_id) === -1 && (
        <Box my={3}>
        <Grid container>
          <Grid item xs={4}  textAlign="center">
            <Typography500 component="p" variant="body3" color="text.secondary">
              {content.valueLabel}
            </Typography500>
            <Typography500 component="p" variant="body1" >
              {formatMoneyValue(deal.value_wc)}
            </Typography500>
          </Grid>
          <Grid
            item
            xs={4}
            textAlign="center"
            className="DSSmiddleborder">
            <Typography500 component="p" variant="body3" color="text.secondary">
              {content.discountLabel}
            </Typography500>
            <Typography500 component="p" variant="body1">
           {`${(Number(deal.savings_percentage)).toFixed(2)}%`}
            </Typography500>
          </Grid>
          <Grid item xs={4} textAlign="center">
            <Typography500 component="p" variant="body3" color="text.secondary">
              {content.youSaveLabel}
            </Typography500>
            <Typography500 component="p" variant="body1">
              {interpolateString(content.perDay, {
                value: formatMoneyValue(deal.savings),
              })}
            </Typography500>
          </Grid>
        </Grid>
        </Box>
      )}
      {!!deal.max_number_of_deals && (
        <Box color="primary" className="DSHurreyText">
          <RiFireLine className="DSHurreyIcon"/>
          <Typography500
            variant="body2"
            component="span"
            color="primary"
            >
            {interpolateString(content.harryRemainingDaysLabel, {
              max_deals: deal.max_number_of_deals,
            })}
          </Typography500>
        </Box>
      )}
    </StyledBox>
  );
};

export { DiscountSection };
